export function addGoogleTag() {
  const googleTagScript = document.createElement('script')
  googleTagScript.src =
    'https://www.googletagmanager.com/gtag/js?id=G-E5P7NH5J35'
  document.head.appendChild(googleTagScript)

  const googleTagConfig = document.createElement('script')
  googleTagConfig.text = `
   window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'G-E5P7NH5J35');
    `
    
  document.head.appendChild(googleTagConfig)
}
